// import { Document, Page } from "react-pdf";
// import { useState } from "react";
// import "react-pdf/dist/Page/AnnotationLayer.css";
// import "react-pdf/dist/Page/TextLayer.css";
// import { Button, Stack, Typography } from "@mui/material";
// // import pdfTest from "../Assets/Post_telegram.pdf";

// function PdfViewerBig({ pdf }) {
//   const [pageNumber, setPageNumber] = useState(1);
//   const [numPages, setNumPages] = useState(null);

//   function onDocumentLoaded({ numPages }) {
//     // console.log("Document Loaded", numPages);
//     setNumPages(numPages);
//     setPageNumber(1);
//   }
//   function nextPage() {
//     setPageNumber((prev) => (prev < numPages ? prev + 1 : prev));
//   }
//   function prevPage() {
//     setPageNumber((prev) => (prev > 1 ? prev - 1 : prev));
//   }

//   return (
//     <div>
//       <Document file={pdf} onLoadSuccess={onDocumentLoaded}>
//         <Page
//           pageNumber={pageNumber}
//           renderAnnotationLayer={false}
//           renderTextLayer={false}
//           // scale={1.5}
//           // rotate={90}
//           width={440}
//           height={440}
//         />
//       </Document>
//       {numPages > 1 && (
//         <Stack direction="row" justifyContent={"space-between"}>
//           <Button onClick={prevPage} disabled={pageNumber <= 1}>
//             ◀ Prev
//           </Button>
//           <Typography sx={{ fontSize: "14px", marginTop: "5px" }}>
//             Page {pageNumber} of {numPages}
//           </Typography>
//           <Button onClick={nextPage} disabled={pageNumber >= numPages}>
//             Next ▶
//           </Button>
//         </Stack>
//       )}
//     </div>
//   );
// }
// export default PdfViewerBig;

function PdfViewerBig({ pdf }) {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <iframe
        src={pdf}
        width="100%"
        height="800px"
        style={{ border: "none" }}
      ></iframe>
    </div>
  );
}

export default PdfViewerBig;
